module.exports = __webpack_public_path__ + "media/inazuma_city_ost_1.d2aee629.mp3";